module.exports = __webpack_public_path__ + "static/media/steering-wheel.7c80ffbc.svg";